import * as d3 from 'd3'
export default {
  methods: {

    draw_Slide() {

      let navi = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 0)`)

      navi
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('width', 30).attr('height', 250) .attr('fill', '#fff')

      navi
      .append('rect')
      .attr('x', 680).attr('y', 0).attr('width', 30).attr('height', 250).attr('fill', '#fff')

      navi
      .append('path')
      .attr('id', 'LEFT')
      .attr('transform', `translate(10, 140) rotate(-90)`)
      .attr('d', 'M17,0,34,9H0Z')
      .attr('fill', '#B4E3FA').attr('visibility', 'hidden').attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).attr('opacity', 0.5)})
      .on('mouseout',  function() {d3.select(this).attr('opacity', 1)})
      .on('click', () => {
        this.slide.x += this.chart.width + 70
        this.slide.sn -= 1
        d3.select('#CANVAS_SLIDE').transition().duration(500)
        .attr('transform', `translate(${this.slide.x}, 0)`)

        if(this.slide.sn == 0) {
          d3.select('#LEFT').attr('visibility', 'hidden')
        } else {
          d3.select('#LEFT').attr('visibility', 'display')
          d3.select('#RIGHT').attr('visibility', 'display')
        }
      }) 

      navi
      .append('path')
      .attr('id', 'RIGHT')
      .attr('transform', `translate(700, 110) rotate(90)`)
      .attr('d', 'M17,0,34,9H0Z')
      .attr('fill', '#B4E3FA').attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).attr('opacity', 0.5)})
      .on('mouseout',  function() {d3.select(this).attr('opacity', 1)})
      .on('click', () => {
        this.slide.x -= this.chart.width + 70
        this.slide.sn += 1
        d3.select('#CANVAS_SLIDE').transition().duration(500)
        .attr('transform', `translate(${this.slide.x}, 0)`)

        if(this.slide.sn == this.chartList.length-2) {
          d3.select('#RIGHT').attr('visibility', 'hidden')
        } else {
          d3.select('#RIGHT').attr('visibility', 'display')
          d3.select('#LEFT').attr('visibility', 'display')
        }
      }) 

    },

  }
}